import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * Service Accounts.
 *
 * Previously listed two invented rows ("default", "sarvkube-sa") while the backend already
 * returned 284 real ones. Now live from Steve.
 */
export default function ServiceAccounts() {
  return (
    <PagedWorkloadPage
      title="Service Accounts" kind="ServiceAccount" resource="serviceaccounts"
      label="service accounts" detail={false}
      cols={['Name', 'Namespace', 'Secrets', 'Age']}
      renderRow={s => [
        <td key="n"><Code>{s.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{s.namespace}</td>,
        <td key="s">{s.secrets}</td>,
        <td key="a"><Age ts={s.created_at} /></td>,
      ]}
    />
  );
}
